/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Modal')
    .directive('accModalNotifications', [
        '$modalStack',
        '$timeout',
        'flashMessagesService',
        (
            $modalStack,
            $timeout,
            flashMessagesService
            ) => ({
            template: '\
                        <div class="note note--modal" ng-class="\'note-\' + type" ng-if="text">\
                            <i class="icon-acc-good"></i>\
                            <i class="icon-acc-info"></i>\
                            <i class="icon-acc-warning"></i>\
                            <span>{{text}}</span>\
                        </div>',
            controller: ['$scope', ($scope) => {
                $scope.text = null;
                $scope.type = null;

                flashMessagesService.subscribe({
                    canHandle: (message) => message.showSuccessInModal || message.type != flashMessagesService.SUCCESS,
                    handle: (message) => {
                        $scope.text = message.text;
                        $scope.type = message.type;

                        if(message.type === flashMessagesService.SUCCESS) {
                            $timeout(() => {
                                $scope.text = null;
                                $scope.type = null;
                            }, message.hideTimeout);
                        }
                    }
                });

                $modalStack.getTop().key.result.finally(() => flashMessagesService.unsubscribe());

                $scope.$on('remove.modal.notification', () => $scope.text = null);
            }],
            link: ($scope, $element) => {
                const $modal = $element.closest('.modal');

                if ($modal.attr('size')) {
                    $scope.size = $modal.attr('size');
                }
            }
        })
    ]);
